export const Input = (props) => {
  const { value, input, type, placeholder, className, label, disabled, maxLength, tabIndex, autoFocus, autoComplete } = props;

  return (
    <div className={className}>
      <label>{label}</label>
      <input
        type={type}
        disabled={disabled}
        autoComplete={autoComplete}
        maxLength={maxLength}
        placeholder={placeholder}
        value={value}
        tabIndex={tabIndex}
        autoFocus={autoFocus}
        {...input}
      />
    </div>
  );
};
